'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	toEmoji = function (codepoint) {
		const codepointArray = codepoint && codepoint.split(' ').map(x => parseInt(x, 16)),
			emoji = codepointArray && String.fromCodePoint.apply(String, codepointArray);
		return emoji;
	};
mmWidgets.fn.stickersFilterWidget = function (params) {
	return mmWidgets.each(this, function () {
		const {stickerList, stickersEditorModel, splittableModel} = params,
			widget = this,
			inputBox = widget.find('input'),
			icon = widget.find('i'),
			sticker = widget.find('[data-mm-role=selected]');
		if (!stickerList || !stickersEditorModel || !splittableModel) {
			throw new Error('invalid-args');
		};
		inputBox.on('input', async () => {
			await stickerList.setFilter(inputBox.val());
		});
		inputBox.on('keydown', (e) => {
			if (e.key === 'Enter') {
				const selected = stickerList.getFirst();
				if (selected) {
					stickersEditorModel.addStickerToActivatedNodes(selected);
				}
			};
			if (e.key === 'Escape') {
				splittableModel.hide();
			}
		});
		stickerList.addEventListener('filter-changed', newFilter => {
			if (inputBox.val() !== newFilter) {
				inputBox.val(newFilter || '');
			}
			if (!newFilter) {
				icon.removeClass('hidden');
				sticker.addClass('hidden');
			} else {
				const selected = stickerList.getFirst();
				if (selected) {
					icon.addClass('hidden');
					sticker.removeClass('hidden');
					sticker.text(toEmoji(selected.codepoint));
				} else {
					icon.removeClass('hidden');
					sticker.addClass('hidden');
				}
			}
		});
	});
};
